export default {
  leCredential: {
    small: 'Verifiable legal entity credentials',
    full: '',
  },
}



// WEBPACK FOOTER //
// ./src/constants/tooltips/credentials.js